import { ComponentType, ReactNode } from "react";
import Spinner from "components/Spinner";
import StatsCardLayout from "components/StatsCardLayout";

export type StatItem = {
  icon?: ComponentType<{ className?: string }>;
  iconClassName?: string;
  label: string;
  value: ReactNode;
  showSpinner?: boolean;
};

// Divider classes per column for the StatsCardLayout 2-col (mobile) / 4-col (md) grid.
const COLUMN_DIVIDERS = [
  "border-r border-b md:border-b-0 border-gray-200",
  "border-b md:border-b-0 md:border-r border-gray-200",
  "border-r border-gray-200",
  "",
];

export const StatsCard = ({
  stats,
  parameters,
}: {
  stats: StatItem[];
  parameters?: ReactNode;
}) => (
  <StatsCardLayout parameters={parameters}>
    {stats.map((stat, i) => {
      const Icon = stat.icon;
      return (
        <div
          key={i}
          className={`${COLUMN_DIVIDERS[i] ?? ""} px-6 py-6 flex flex-col items-center justify-center`}
        >
          <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
            {stat.showSpinner ? (
              <Spinner size="XS" theme="primary" />
            ) : Icon ? (
              <Icon className={stat.iconClassName ?? "w-4 h-4"} />
            ) : null}
            <span>{stat.label}</span>
          </div>
          <p className="text-lg font-semibold text-gray-900">{stat.value}</p>
        </div>
      );
    })}
  </StatsCardLayout>
);

export default StatsCard;
